<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('usermanage.account')">
        <el-input :placeholder="$t('usermanage.placeholder')" v-model="filter.account" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('usermanage.username')">
        <el-input :placeholder="$t('usermanage.placeholder1')" v-model="filter.username" clearable></el-input>
      </el-form-item>

      <el-form-item :label="$t('usermanage.phone')">
        <el-input class="input-small" :placeholder="$t('usermanage.placeholder2')" v-model="filter.phone" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('usermanage.Status')">
        <el-select v-model="filter.state" class="input-mini">
          <el-option value="" :label="$t('usermanage.Status1')"></el-option>
          <el-option :value="0" :label="$t('usermanage.Status2')"></el-option>
          <el-option :value="1" :label="$t('usermanage.Status3')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column :label="$t('usermanage.serial')" type="index" width="80"></el-table-column>
      <el-table-column label="登录账号" prop="Account"></el-table-column>
      <el-table-column label="用户名称" prop="NickName"></el-table-column>
      <el-table-column :label="$t('usermanage.Role_name')" prop="Role_name" show-overflow-tooltip></el-table-column>
      <el-table-column label="所属商户/平台" prop="merchant_name"></el-table-column>
      <el-table-column :label="$t('usermanage.phone')" prop="phone"></el-table-column>
      <el-table-column :label="$t('usermanage.Status')" prop="Status">
        <template slot-scope="{ row }">
          <el-tag type="success" effect="plain" v-if="row.Status === 0">{{ $t("usermanage.Status2") }}</el-tag>
          <el-tag type="danger" effect="plain" v-else>{{ $t("usermanage.Status3") }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('usermanage.CreateTime')" sortable prop="CreateTime" show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="200px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" @click="onEnable(row)" v-permision_tjtf="'disable_enable'">{{ row.Status == 0 ? $t("usermanage.Status3") : $t("usermanage.Status4") }}</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改用户 -->
    <el-dialog :visible.sync="visible.editUser" :title="isUpdate ? $t('publics.edit') : $t('publics.add')" width="800px">
      <!-- 添加 key 和 autocomplete 属性 -->
      <el-form :key="formRandomId" label-position="right" label-width="140px" v-loading="formLoading" :model="userForm" :rules="formRules" ref="userForm" autocomplete="off">
        <el-row>
          <el-col :span="11">
            <el-form-item label="登录账号" prop="account">
              <!-- 添加 autocomplete 和 readonly/onfocus 属性 -->
              <el-input :placeholder="$t('usermanage.placeholder')" v-model="userForm.account" :name="'account_' + formRandomId" autocomplete="new-username" />
            </el-form-item>
            <el-form-item v-if="!isUpdate" :label="$t('usermanage.password')" prop="password">
              <!-- 添加 autocomplete 属性 -->
              <el-input type="password" :placeholder="$t('usermanage.placeholder3')" v-model="userForm.password" :name="'password_' + formRandomId" autocomplete="new-password" />
            </el-form-item>
            <el-form-item v-if="isUpdate" :label="$t('usermanage.isUpdatemsg')" prop="password">
              <el-switch v-model="userForm.isUpdatePwd" @change="onIsUpdatePwd" />
              <!-- 添加 autocomplete 属性 -->
              <el-input type="password" v-if="userForm.isUpdatePwd" :placeholder="$t('usermanage.placeholder3')" v-model="userForm.password" :name="'new_password_' + formRandomId" autocomplete="new-password" />
            </el-form-item>
            <el-form-item label="所属商户/平台" prop="merchant_id">
              <el-select v-model="userForm.merchant_id">
                <el-option v-for="item in merchants" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="用户名称" prop="username">
              <!-- 添加 autocomplete 属性 -->
              <el-input :placeholder="$t('usermanage.placeholder1')" v-model="userForm.username" :name="'username_' + formRandomId" autocomplete="new-username" />
            </el-form-item>
            <el-form-item :label="$t('usermanage.phone')" prop="phone">
              <!-- 添加 autocomplete 和 readonly/onfocus 属性 -->
              <el-input :placeholder="$t('usermanage.placeholder2')" v-model="userForm.phone" :name="'phone_' + formRandomId" autocomplete="off" readonly @focus="handlePhoneFocus" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="角色" prop="checkedRoles">
          <el-select v-model="userForm.checkedRoles" multiple placeholder="请选择" style="min-width: 560px">
            <el-option v-for="item in roles" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible.editUser = false">{{ $t("usermanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("usermanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { getUserList, getRoleSelectList, getMerchantSelectList, addUser, updateUser, deleteUser, getUserInfoList, enableUser } from "@/api/user"
export default {
  name: "UserManager",
  mixins: [pageMixin],
  data() {
    return {
      filter: {
        account: "",
        username: "",
        phone: "",
        state: ""
      },
      tableData: [],
      visible: {
        editUser: false
      },
      loading: false,
      roles: [],
      merchants: [],
      userForm: {
        username: "",
        password: "",
        checkedRoles: [],
        merchant_id: "",
        account: "",
        phone: "",
        avatar: "",
        checkedLines: [],
        isUpdatePwd: false
      },
      formRules: {},
      checkAll: false,
      lines: [],
      isIndeterminate: false,
      formLoading: false,
      isUpdate: false,
      uid: "", //用户id
      domains: [
        {
          value: ""
        }
      ],
      formRandomId: "" // 添加随机ID，用于防止浏览器自动填充
    }
  },
  created() {
    const checkPwd = (rule, value, callback) => {
      if (this.isUpdate) {
        //修改用户
        if (this.userForm.isUpdatePwd && !value) {
          return callback(new Error(`${this.$t("usermanage.placeholder3")}`))
        }
      } else {
        //新增用户
        if (!value) {
          return callback(new Error(`${this.$t("usermanage.placeholder3")}`))
        }
      }
      callback()
    }
    const checkphone = (rule, value, callback) => {
      const reg = /^((13[0-9])|(14[5-7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|(19[0-9])|166|198|199|(147))\d{8}$/
      if (this.userForm.phone != "") {
        let phones = this.userForm.phone.split(",")
        phones.forEach((e) => {
          if (!reg.test(e)) {
            return callback(new Error(e + `${this.$t("usermanage.placeholder4")}`))
          }
        })
      }
      callback()
    }
    this.formRules = {
      username: [{ required: true, message: this.$t("usermanage.placeholder1"), trigger: "blur" }],
      password: [{ validator: checkPwd, message: this.$t("usermanage.placeholder3"), trigger: "blur" }],
      phone: [{ validator: checkphone, message: this.$t("usermanage.placeholder5"), trigger: "blur" }],
      checkedRoles: [{ required: true, message: this.$t("usermanage.placeholder6"), trigger: "blur" }],
      merchant_id: [{ required: true, message: "请选择商户", trigger: "blur" }],
      account: [{ required: true, message: this.$t("usermanage.placeholder"), trigger: "blur" }]
    }
    this.getData()
  },
  methods: {
    handleOptionClick(e) {},
    // 处理电话输入框的焦点事件，移除readonly属性
    handlePhoneFocus() {
      const phoneInput = document.querySelector(`input[name='phone_${this.formRandomId}']`)
      if (phoneInput && phoneInput.hasAttribute("readonly")) {
        phoneInput.removeAttribute("readonly")
      }
    },

    onDelete(row) {
      this.$confirm(`${this.$t("usermanage.deletetit")}`, `${this.$t("usermanage.tic")}`, {
        type: "warning"
      })
        .then((res) => {
          deleteUser({
            Id: row.Id
          }).then((res) => {
            this.$message.success(`${this.$t("publics.deletesuccessful")}`)
            this.toFilter()
          })
        })
        .catch(() => {})
    },
    onEnable(row) {
      this.$confirm(`${row.Status == 0 ? `${this.$t("usermanage.enatit1")}` : `${this.$t("usermanage.enatit2")}`}`, `${this.$t("usermanage.tic")}`, {
        type: "warning"
      })
        .then((res) => {
          enableUser({
            Id: row.Id
          }).then((res) => {
            this.$message.success(`${this.$t("usermanage.opsuccess")}`)
            this.getData()
          })
        })
        .catch(() => {})
    },
    onIsUpdatePwd(val) {
      if (!val) this.userForm.password = ""
    },
    onUpdate(row) {
      // 重置表单
      this.$refs.userForm && this.$refs.userForm.resetFields()
      this.visible.editUser = true
      this.isUpdate = true
      this.userForm.username = row.NickName
      this.userForm.isSmsPush = row.is_SMSpush
      this.userForm.account = row.Account
      this.userForm.phone = row.phone
      this.userForm.avatar = row.imgpath
      this.userForm.merchant_id = row.merchant_id
      this.userForm.isUpdatePwd = false
      this.uid = row.Id

      // 生成随机ID，防止浏览器自动填充
      this.formRandomId = "form_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9)

      this.formLoading = true
      let apis = [getRoleSelectList(), getUserInfoList({ id: row.Id }), getMerchantSelectList()]
      Promise.all(apis)
        .then((res) => {
          this.roles = res[0].data
          this.userForm.checkedRoles = res[1].Rdata
          this.merchants = res[2].data
        })
        .finally(() => {
          this.formLoading = false
        })
    },
    handleCheckAllChange(val) {
      let lineIds = this.lines.map((item) => item.ID)
      this.userForm.checkedLines = val ? lineIds : []
      this.isIndeterminate = false
    },
    handlecheckedLinesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.lines.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.lines.length
    },
    getData() {
      this.loading = true
      getUserList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        where: JSON.stringify({
          rules: [
            { field: "Account", op: "like", value: this.filter.account },
            { field: "NickName", op: "like", value: this.filter.username },
            { field: "phone", op: "like", value: this.filter.phone },
            { field: "Status", op: "like", value: this.filter.state }
          ],
          op: "and"
        })
      })
        .then((res) => {
          this.tableData = res.dt
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    onAdd() {
      this.visible.editUser = true
      this.isUpdate = false
      this.userForm = this.$options.data().userForm
      this.isIndeterminate = false

      // 生成随机ID，防止浏览器自动填充
      this.formRandomId = "form_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9)

      this.formLoading = true
      let apis = [getRoleSelectList(), getMerchantSelectList()]
      Promise.all(apis)
        .then((res) => {
          this.roles = res[0].data
          this.merchants = res[1].data
        })
        .finally(() => {
          this.formLoading = false
        })
    },
    onSubmit() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          if (this.isUpdate) {
            if (this.userForm.password.trim() == "" && this.userForm.isUpdatePwd) {
              this.$message.error(`${this.$t("usermanage.placeholder7")}`)
              loading.close()
              return
            }
            if (this.userForm.password.trim().length < 6 && this.userForm.isUpdatePwd) {
              this.$message.error(`${this.$t("usermanage.placeholder8")}`)
              loading.close()
              return
            }
            updateUser({
              Id: this.uid,
              Account: this.userForm.account,
              Password: this.userForm.password,
              NickName: this.userForm.username,
              phone: this.userForm.phone,
              role_id: this.userForm.checkedRoles.join(","),
              merchant_id: this.userForm.merchant_id,
              imgpath: this.userForm.avatar,
              is_SMSpush: this.userForm.isSmsPush,
              devicearchivesids: this.userForm.checkedLines.join(",")
            })
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editUser = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            if (this.userForm.password.trim() == "") {
              this.$message.error(`${this.$t("usermanage.placeholder7")}`)
              loading.close()
              return
            }
            if (this.userForm.password.trim().length < 6) {
              this.$message.error(`${this.$t("usermanage.placeholder8")}`)
              loading.close()
              return
            }
            addUser({
              Account: this.userForm.account,
              Password: this.userForm.password,
              NickName: this.userForm.username,
              phone: this.userForm.phone,
              role_id: this.userForm.checkedRoles.join(","),
              merchant_id: this.userForm.merchant_id,
              imgpath: this.userForm.avatar,
              is_SMSpush: this.userForm.isSmsPush,
              devicearchivesids: this.userForm.checkedLines.join(",")
            })
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editUser = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    },
    removeDomain(item) {
      var index = this.domains.indexOf(item)
      if (index !== -1) {
        this.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.domains.push({
        value: "",
        key: Date.now()
      })
    }
  }
}
</script>

<style scoped></style>
